export default class DownloadUtil {

  static downloadCsvBlob (blob, fileName) {
    if (window.navigator.msSaveOrOpenBlob) {
      // for IE,Edge
      window.navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
      // for chrome, firefox
      const url = URL.createObjectURL(new Blob([blob], { type: 'text/csv' }))
      const linkEl = document.createElement('a')
      linkEl.href = url
      linkEl.setAttribute('download', fileName)
      document.body.appendChild(linkEl)
      linkEl.click()

      URL.revokeObjectURL(url)
      linkEl.parentNode.removeChild(linkEl)
    }
  }

  static getFileNameFromContentDisposition (disposition) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    const matches = filenameRegex.exec(disposition)
    if (matches != null && matches[1]) {
      const fileName = matches[1].replace(/['"]/g, '')
      return decodeURI(fileName)
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/donwload.js